import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  // Check if admin token exists in localStorage
  const token = localStorage.getItem("adminToken");

  // If no token, redirect to login page
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Token exists, allow access
  return children;
}
